import { Action } from "../../../actions/actions";
import { GamesActionTypes } from "../actions/actionTypes";

export function creatingGame(
    state: any = {
        values: {
            name: "",
            type: undefined,
            software_house: undefined,
            image: undefined,
            image_base64: undefined
        },
        isValid: false
    },
    action: Action
) {
    const values =
        state && action.payload
            ? { ...state.values, ...action.payload.values }
            : action.payload
            ? action.payload.values
            : null;

    const isValid = state && action.payload ? action.payload.isValid : false;

    if(values){
        values.software_house = typeof values.software_house === "object" ? values.software_house.id : values.software_house
    }

    switch (action.type) {
        case GamesActionTypes.UPDATE_CREATING_GAME:
            return {
                values,
                isValid: isValid
            };

        case GamesActionTypes.CREATE_GAME_SUCCESS:
        case GamesActionTypes.EDIT_GAME_SUCCESS:
            return null;

        case GamesActionTypes.CREATE_GAME_RESET:
            return null;

        default:
            return state;
    }
}
